import React from "react";
import { sanitizeInput, formatProductTag } from "../Helper";

const useFormData = (integration) => {
  const getInitialFormData = () => {
    const defaultData = {
      amount: "",
      currency: "USD",
      description: "Payment Widget",
      product_name: "",
      redirect_url: "",
      gohighlevel_enabled: false,
      gohighlevel_api_key: "",
      custom_tags: ["", "", ""],
      pay_button_cta: "Pay Now",
      pay_button_note: "",
    };

    if (!integration) return defaultData;

    try {
      if (
        integration.description &&
        integration.description.startsWith("[") &&
        integration.description.endsWith("]")
      ) {
        const descData = JSON.parse(
          integration.description.replace(/^\[|\]$/g, "")
        );

        let customTags = ["", "", ""];
        if (descData.gohighlevel_tags) {
          const allTags = descData.gohighlevel_tags.split(",");
          const filteredTags = allTags.filter(
            (tag) =>
              tag !== "not_paid" &&
              tag !== "paid" &&
              (descData.product_name
                ? tag !== formatProductTag(descData.product_name)
                : true)
          );
          filteredTags.forEach((tag, index) => {
            if (index < 3) customTags[index] = tag;
          });
        }

        return {
          amount: integration.pay_button_amount || "",
          currency: integration.pay_button_currency || "USD",
          description: sanitizeInput(descData.description || "Payment Widget"),
          product_name: sanitizeInput(descData.product_name || ""),
          redirect_url: integration.redirect_url || "",
          gohighlevel_enabled: descData.gohighlevel_enabled || false,
          gohighlevel_api_key: "",
          custom_tags: customTags.map((tag) => sanitizeInput(tag)),
          pay_button_cta: sanitizeInput(descData.pay_button_cta || "Pay Now"),
          pay_button_note: sanitizeInput(descData.pay_button_note || ""),
        };
      }

      return {
        ...defaultData,
        amount: integration.pay_button_amount || "",
        currency: integration.pay_button_currency || "USD",
        description: sanitizeInput(integration.description || "Payment Widget"),
        product_name: sanitizeInput(integration.product_name || ""),
        redirect_url: integration.redirect_url || "",
        pay_button_cta: sanitizeInput(integration.pay_button_cta || "Pay Now"),
        pay_button_note: sanitizeInput(integration.pay_button_note || ""),
      };
    } catch (e) {
      console.error("Error parsing integration data:", e);
      return {
        ...defaultData,
        description: sanitizeInput(defaultData.description),
        product_name: sanitizeInput(defaultData.product_name),
        custom_tags: defaultData.custom_tags.map((tag) => sanitizeInput(tag)),
        pay_button_cta: sanitizeInput(defaultData.pay_button_cta),
        pay_button_note: sanitizeInput(defaultData.pay_button_note),
      };
    }
  };

  return getInitialFormData();
};

export default useFormData;
